import request from '@/utils/request'

const url1 = 'elevator'
const url2 = 'camera'
const elevatorSensorUrl = 'elevator/sensor'

/** 获取电梯列表 */
export function searchElevator(data) {
  return request({
    url: `${url1}/searchElevator`,
    method: 'post',
    data
  })
}

/** 获取电梯列表 */
export function deviceList(data) {
  return request({
    url: `${url1}/deviceList/${data}`,
    method: 'get',
    data
  })
}

/** 获取电梯列表 */
export function searchElevatorNotPage(data) {
  return request({
    url: `${url1}/searchElevatorNotPage`,
    method: 'post',
    data
  })
}
/** 获取电梯列表 */
export function searchElevatorDownload(data) {
  return request({
    url: `${url1}/test`,
    method: 'post',
    responseType: 'blob',
    data
  })
}

/** 获取电梯详情 */
export function getElevatorDetail(data) {
  return request({
    url: `${url1}/${data}`,
    method: 'get'
  })
}

/** 获取电梯监控画面Url  */
export function getElevatorMonitorUrl(data) {
  return request({
    url: `${url2}/${data}`,
    method: 'get'
  })
}

/** 获取电梯监控画面Url TOKEN  */
export function getElevatorMonitorUrlEzopenToken(data) {
  return request({
    url: `${url2}/ezopenToken`,
    method: 'get'
  })
}

/** 获取电梯监控画面展示字段  */
export function getPageDisplay(elevatorCode) {
  return request({
    url: `${elevatorSensorUrl}/pageDisplay/${elevatorCode}`,
    method: 'get'
  })
}

/** 获取电梯数量  */
export function countElevator(data) {
  return request({
    url: `${url1}/countElevator`,
    method: 'get'
  })
}

/** 供编辑使用的详情查询  */
export function getElevatorInfo(data) {
  return request({
    url: `${url1}/getElevatorInfo/${data}`,
    method: 'get'
  })
}

/** 电梯编辑  */
export function editElevatorInfo(data) {
  return request({
    url: `${url1}/editElevatorInfo`,
    method: 'post',
    data
  })
}

/** 添加电梯  */
export function addElevatorInfo(data) {
  return request({
    url: `${url1}/addElevatorInfo`,
    method: 'post',
    data
  })
}

/** 获取电梯图片  */
export function getElevatorImg(data) {
  return request({
    url: `${url1}/getElevatorImg/${data}`,
    method: 'post'
  })
}

/** 删除文件 */
export function deleteElevatorImg(elevatorId, fileId) {
  return request({
    url: `${url1}/deleteElevatorImg/${elevatorId}/${fileId}`,
    method: 'post'
  })
}

/** 设置楼层信息(包含额定速度信息) */
export function updateFloorElevator(data) {
  return request({
    url: `${url1}/updateFloorElevator`,
    method: 'post',
    data
  })
}

/** 设置楼层信息 */
export function getElevatorDeviceDetailList(elevatorId) {
  return request({
    url: `${url1}/deviceDetailList/${elevatorId}`,
    method: 'get'
  })
}

/** 初始化统计数据 */
export function initInstallTime(elevatorId) {
  return request({
    url: `${url1}/initInstallTime/${elevatorId}`,
    method: 'get'
  })
}

/** 删除数据 */
export function initElevator(elevatorId) {
  return request({
    url: `${url1}/initElevator/${elevatorId}`,
    method: 'get'
  })
}

export function getElevatorHeatMapStatistics(data) {
    return request({
        url: `${url1}/elevatorHeatMapNew`,
        method: 'post',
        data
    })
}

export function getElevatorPassengerFlow(data) {
  console.log(data,'1234234234');
  return request({
    url: `${url1}/getElevatorPassengerFlow?elevatorCode=${data.codes}&startTime=${data.startDate}&endTime=${data.endDate}`,
    method: 'get'
  })
}

/** 获取电梯列表(根据当前用户进行筛选) */
export function searchElevatorByUserId(data) {
  return request({
    url: `${url1}/searchElevatorByUserId`,
    method: 'post',
    data,
  })
}

export function searchElevatorByUserId1(data) {
  return request({
    url: `${url1}/searchRuijinElevatorSimpleList`,
    method: 'post',
    data,
  })
}

// 上传报告
export function uploadReport(data) {
  return request({
    url: `/inspection/report/add`,
    method: 'post',
    data,
  })
}

// 查询报告
export function searchReport(data) {
  return request({
    url: `/inspection/report/page`,
    method: 'post',
    data,
  })
}

// 删除报告
export function delReport(data) {
  return request({
    url: `/inspection/report/delete?id=${data.id}`,
    method: 'delete',
  })
}

// 上传零配件记录
export function uploadSpareParts(data) {
  return request({
    url: `/spare/parts/replacement/add`,
    method: 'post',
    data,
  })
}

// 零配件记录查询
export function searchSpareParts(data) {
  return request({  
    url: `/spare/parts/replacement/page`,
    method: 'post',
    data,
  })
}

// 删除零配件记录
export function delSpareParts(data) {
  return request({
    url: `/spare/parts/replacement/delete?id=${data.id}`,
    method: 'delete',
  })
}
